import { useRouter } from "next/router";
import { useTeams } from "queries/teams";
import { isDev } from "ui/lib/helpers";

const PAGE_LABELS: Record<string, string> = {
  "/programs/[bootcampId]/overview": "Calendar",
  "/programs/[bootcampId]/chat": "Chat",
  "/programs/[bootcampId]/movements": "Movements",
  "/programs/[bootcampId]/members": "Members",
  "/programs/[bootcampId]/workout/[workoutId]": "Workout",
  "/programs/[bootcampId]/details": "Team Details",
  "/programs/[bootcampId]/details/movements": "Movement Library",
  "/programs/[bootcampId]/details/imagery": "Workout Imagery",
  "/programs/[bootcampId]/details/equipment": "Equipment",
  "/programs/[bootcampId]/details/lessons": "Lessons",
  "/members/[memberId]": "Member",
  "/blocks": "Blocks",
  "/blocks/[blockId]": "Block",
  "/open-season": "Open Season",
  "/curated-rooms": "Curated Rooms",
  "/home-shelves": "Home Shelves",
  "/remote-config": "Remote Config",
  "/links/builder": "Ladder Links",
  "/promos": "Promo Codes",
  "/badges": "Badges",
  "/more": "More",
};

export const pageLabel = (pathname: string) => PAGE_LABELS[pathname];

/** "Calendar · Crews Control · Apollo": the page, then the team when the route has one. Dev tabs end "Apollo Dev". */
export const usePageTitle = () => {
  const { pathname, query } = useRouter();
  const bootcampId =
    typeof query.bootcampId === "string" ? query.bootcampId : null;
  const { getTeamById } = useTeams();
  const team = bootcampId ? getTeamById(bootcampId)?.name : undefined;
  const app = isDev ? "Apollo Dev" : "Apollo";
  return [pageLabel(pathname), team, app].filter(Boolean).join(" · ");
};
